var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-5" },
    [
      _c("errors-alert", { attrs: { errors: _vm.errors } }),
      _vm._v(" "),
      typeof _vm.errorMessagesList !== "undefined" &&
      typeof _vm.errorMessagesList === "object" &&
        _vm.errorMessagesList.length !== 0 &&
        _vm.errors.length === 0
        ? _c("errors-alert", { attrs: { errors: _vm.errorMessagesList } })
        : _vm._e(),
      _vm._v(" "),
      _vm.backButton
        ? _c(
            "v-btn",
            {
              attrs: {
                color: "secondary",
                disabled: _vm.$store.state.config.stepLoading
              },
              on: {
                click: function($event) {
                  return _vm.$emit("step-back")
                }
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.backButton === true ? "Back" : _vm.nextButton) +
                  "\n    "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.nextButton
        ? _c(
            "v-btn",
            {
              attrs: {
                color: "primary",
                loading: _vm.$store.state.config.stepLoading,
                disabled: _vm.disabled_status
              },
              on: {
                click: function($event) {
                  return _vm.$emit("step-next")
                }
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.nextButton === true ? "Continue" : _vm.nextButton
                  ) +
                  "\n    "
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }